var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SVGInline-svg Slider__SliderArrow-svg CarouselRow__SliderArrow-svg Slider__SliderArrow--right-svg CarouselRow__SliderArrow--right-svg",
    viewBox: "0 0 37 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "__140BNN4__path-1__260",
    points: "42.1862348 226 38 230.23 51.5978408 244 38 257.77 42.1862348 262 60 244"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-54.5%",
    y: "-33.3%",
    width: "209.1%",
    height: "166.7%",
    filterUnits: "objectBoundingBox",
    id: "__140BNN4__filter-2__260"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.161378614 0 0 0 0 0.161378614 0 0 0 0 0.161378614 0 0 0 0.372877038 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__140BNN4__Symbols__260",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__140BNN4__gallery_toggle__260",
    transform: "translate(-30.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__140BNN4__Shape-Copy-3__260",
    transform: "translate(49.000000, 244.000000) rotate(-180.000000) translate(-49.000000, -244.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#__140BNN4__filter-2__260)",
    xlinkHref: "#__140BNN4__path-1__260"
  }), /*#__PURE__*/React.createElement("use", {
    className: "element-to-fill",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#__140BNN4__path-1__260"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrowLeftWhite.9d4a91e7.svg";
export { ForwardRef as ReactComponent };